import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { conflictType } from 'components/Conflict/propTypes';
import ConflictMessage from 'components/Conflict/ConflictMessage';
import OutOfStock from 'components/Conflict/OutOfStock';
import Resolution from 'components/Conflict/Resolution';
import { TEMPORARILY_UNAVAILABLE } from 'constants/conflicts';
import ViewAlternativesOrRemove from './ViewAlternativesOrRemove';

export const MESSAGE_TYPE = {
  short: 'shortItem',
  long: 'longItem',
};

const isTemporarilyUnavailable = message => message === TEMPORARILY_UNAVAILABLE;

const Conflict = ({
  className = '',
  conflict,
  disableResolution = false,
  messageType,
  textOnly = false,
  isInTrolley,
  removeFromTrolley,
  position,
  listDefinitions,
}) => {
  if (!conflict) return null;

  const { messages = {}, resolutionActions = [], outOfStock = false, productId } = conflict;
  const message = messages[messageType];

  if (outOfStock) {
    return (
      <OutOfStock message="Sold out online" className={className}>
        <ViewAlternativesOrRemove
          {...{
            isInTrolley,
            removeFromTrolley,
            productId,
            conflictMessage: messages.shortItem,
            position,
            listDefinitions,
          }}
        />
      </OutOfStock>
    );
  }
  if (!message) return null;

  if (!disableResolution && resolutionActions.length > 0) {
    const resolutionProps = {
      className,
      conflict,
      conflictMessage: message,
      textOnly,
    };

    return <Resolution {...resolutionProps} />;
  }

  if (isTemporarilyUnavailable(message)) {
    return (
      <OutOfStock message={message} className={className}>
        <ViewAlternativesOrRemove
          isInTrolley={isInTrolley}
          productId={productId}
          removeFromTrolley={removeFromTrolley}
          position={position}
          conflictMessage={messages.shortItem}
        />
      </OutOfStock>
    );
  }

  return <ConflictMessage className={className} text={message} textOnly={textOnly} />;
};

Conflict.propTypes = {
  className: PropTypes.string,
  conflict: conflictType,
  disableResolution: PropTypes.bool,
  entityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  entityType: PropTypes.oneOf(['products', 'trolley']).isRequired,
  messageType: PropTypes.oneOf(Object.values(MESSAGE_TYPE)).isRequired,
  textOnly: PropTypes.bool,
  isInTrolley: PropTypes.bool,
  removeFromTrolley: PropTypes.func,
  position: PropTypes.number,
};

export default Conflict;
